<template>
  <div class="container">
    <template v-if="showPage">
    <!--会议室信息  -->
    <div class="room_mess">
      <h2>会议室</h2>
      <div class="room_detail">
        <div class="room_detail_left">
          <div class="left_title">
            <img src="@/assets/images/themes/icon_location_0.png" />
            <span>{{metingRoom.name}}</span>
          </div>
          <p class="left_text"><span>面积{{metingRoom.area}}㎡</span><span>座位{{metingRoom.num}}人</span></p>
        </div>
        <div class="room_detail_right">
          <img :src="metingRoom.images" />
        </div>
      </div>
    </div>
    <!-- 预订信息 -->
    <div class="appoint_mess">
      <h2>预订信息</h2>
      <ul>
        <li>
          <span>预订时段</span>
          <p>{{orderInfo.payDate}} {{activeWeekDay}} {{orderInfo.beginTime}}-{{orderInfo.endTime}}</p>
        </li>
        <li>
          <span>会议主题</span>
          <p>{{orderInfo.theme}}</p>
        </li>
        <li>
          <span>预订人</span>
          <p>{{common.userTenantInfo.userName}}</p>
        </li>
        <li>
          <span>手机号</span>
          <p>{{common.userInfo.phone||common.userInfo.account}}</p>
        </li>
        <li>
          <span>下单时间</span>
          <p>{{orderInfo.createTime|formatTime(11)}}</p>
        </li>
      </ul>
      <span v-if="orderInfo.status == 0" class="appoint_status">已预订</span>
        <img class="cancel_icon" v-else-if="orderInfo.status == 1" src="@/assets/images/icon_audit_completed.png" />
        <img class="cancel_icon" v-else src="@/assets/images/icon_canceled.png" />
    </div>
     <!-- 底部按钮 -->
    <footer class="footer_box" v-if="orderInfo.status == 0">
        <span class="cancel_btn" @click.stop="cancelOrder(orderInfo.id)">取消订单</span>
        <span class="qr_btn" @click.stop="getTenantQrCode(orderInfo)"><img src="@/assets/images/icon_member_qrcode.png" />门禁码</span>
    </footer>
    <!-- 门禁码 -->
    <mt-popup  v-model="qrcode_box" position="center">
        <div class="qrcode_box">
            <div class="qrcode_top">
                <p class="qr_title">门禁码</p>
                <p class="qr_desc">刷码建议距离10cm左右</p>
                <div class="QRCode" ref="qrCodeUrl"></div>
                <!-- <p class="qr_code">FK-021-00000043</p> -->
            </div>
            <img class="close" @click="qrcode_box = false" src="@/assets/images/icon_popup_close.png" />
        </div>
    </mt-popup>
    </template>
  </div>
</template>
<script>
import util from "../../../utils/util";
import { mapState } from "vuex";
import {getMeetingRoomDetailByIdSmart,getMeetingOrderDetailByIdSmart,cancelMeetingOrderSmart,desEncrypt} from "../../../utils/api";
import QRCode from 'qrcodejs2';
export default {
  name: "roomPay",
  components: {},
  data() {
    return {
        orderInfo: {},
        metingRoom:{},
        qrcode_box:false,
        timestamp:'',
        qrcodeTool:'',
        showPage:false
    };
  },
  filters: {
    date: function(data) {
      if (data) {
        return data.split('-').join('.')
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    }),
    activeWeekDay(){
        return util.getWeek(this.orderInfo.payDate)
    }
  },
  created() {
    this.getMeetingRoomDetailByIdSmart();
    this.getMeetingOrderDetailByIdSmart();
  },
  methods: {
    // 获取会议室数据
    getMeetingRoomDetailByIdSmart() {
      util.showLoading("加载中...");
      getMeetingRoomDetailByIdSmart({
        meetingRoomId: this.$route.query.meetingRoomId || ''
      }).then(res => {
        console.log(res)
        util.hideLoading();
        if (res.res && res.res.code === 10000 && res.body) {
          this.metingRoom = res.body.room;
        }
      });
    },
    getMeetingOrderDetailByIdSmart(){
        getMeetingOrderDetailByIdSmart({orderId:this.$route.query.id}).then(res=>{
            console.log(res)
            this.showPage = true;
            if(res.res && res.body && res.res.code === 10000){
                this.orderInfo = res.body.order
            }else{
                util.showToast(res.res.msg)
            }
        })
    },
    cancelOrder(id){
        util.showModal('', '确定要取消该订单吗？', true, '确定', () => {
            util.showLoading()
            cancelMeetingOrderSmart({orderId:id}).then(res => {
            if (res.res && res.res.code === 10000) {
                util.hideLoading()
                util.showToast("已取消")
                setTimeout(() => {
                    this.getMeetingOrderDetailByIdSmart();
                }, 1000);
            }else{
                util.showToast(res.res.msg)
            }
            });
        });
    },
    //获取二维码数据
    getTenantQrCode(item) {
        util.showLoading()
        let content = {
            uid:item.id,
            operationType: "3", //1门禁,2访客，3.会议室
            userId:item.userId,
            marketId:item.id,
            timestamp: this.timestamp.toString()
        };
        desEncrypt(content).then(res => {
            util.hideLoading()
            this.qrcode_box = true;
            this.creatQrCode(res);
        })
    },
    //js生成二维码
    creatQrCode(dic) {
      if(!this.qrcodeTool){
        var wh =document.body.clientWidth;
        var w =170*wh/375;
        var h =170*wh/375;
        this.qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
          text: dic ,
          width: w,
          height: h,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.M
        })
      }else{
        this.qrcodeTool.clear(); // 清除代码
        this.qrcodeTool.makeCode(dic); // 生成另外一个二维码
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container {
  background: @colore;
}
h2{
  height:44px;
  line-height: 44px;
  font-size:32px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  border-bottom:2px solid #EAEAEA;
  padding-bottom:28px;
  margin-bottom:28px;
}
.room_mess{
  padding:28px;
  border-radius: 8px;
  background:#fff;
  margin:20px;
  .room_detail{
    .flex();
    justify-content: space-between;
    .room_detail_left{
      flex:1;
      .left_title{
        .flex();
        align-items: center;
        margin-bottom:20px;
        img{
          display:block;
          width:36px;
          height:36px;
          margin-right:10px;
        }
        span{
          font-size:36px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          line-height:50px;
        }
      }
      .left_text{
        .flex();
        margin-bottom:8px;
        span{
          height:44px;
          border-radius:8px;
          border:2px solid rgba(218,218,218,1);
          line-height: 40px;
          text-align: center;
          padding:0 8px;
          font-size:24px;
          color:rgba(102,102,102,1);
          margin-right:10px;
          box-sizing:border-box;
        }
      }
    }
    .room_detail_right{
      width:200px;
      height:150px;
      img{
        display: block;
        width:200px;
        height:150px;
        border-radius: 8px;
      }
    }
  }
}
.appoint_mess{
  padding:28px;
  border-radius: 8px;
  background:#fff;
  margin:20px;
  padding-top:28px;
  position:relative;
  li{
    .flex();
    padding-bottom: 28px;
    span{
      width:140px;
      font-size:28px;
      color:rgba(153,153,153,1);
      line-height:40px;
    }
    p{
      flex:1;
      flex-wrap: wrap;
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:40px;
    }
  }
}
.footer_box{
  position:fixed;
  bottom:0;right:0;left:0;
  background:#fff;
  padding:16px 28px;
  box-sizing: border-box;
  .flex();
  justify-content:flex-end;
  span{
        margin-left:20px;
        box-sizing: border-box;
    }
  .cancel_btn{
        width:160px;
        height:68px;
        border-radius:8px;
        border:2px solid rgba(218,218,218,1);
        text-align:center;
        line-height: 64px;
        box-sizing:border-box;
        color:rgba(102,102,102,1);
    }
    .qr_btn{
        .flex();
        justify-content: center;
        align-items: center;
        width:168px;
        height:68px;
        background:rgba(23,64,218,1);
        border-radius:8px;
        line-height: 68px;
        font-size:28px;
        color:#fff;
        img{
            width:28px;
            height:28px;
            margin-right:8px;
        }
    }
}
.appoint_status{
        position: absolute;
        right:28px;
        top:28px;
        font-size:26px;
        color:rgba(253,152,56,1);
        line-height:36px;
        font-size:28px;
    }
    .cancel_icon{
        position: absolute;
        right:24px;
        top:24px;width:120px;
        height:120px;
    }
    .qrcode_box{
    .flex(column);
    align-items: center;
    justify-content: center;
    .qrcode_top{
        .flex(column);
        align-items: center;
        justify-content: center;
        width:670px;
        background:#fff;
        border-radius:16px;
        padding-bottom:120px;
        .qr_title{
            height:50px;
            font-size:36px;
            font-weight:bold;
            color:rgba(51,51,51,1);
            line-height:50px;
            margin:60px 0 20px;
        }
        .qr_desc{
            height:40px;
            font-size:28px;
            color:rgba(255,126,30,1);
            line-height:40px;
            margin-bottom:60px;
        }
        .QRCode{
            width:340px;
            height:340px;
        }
        .qr_code{
            height:40px;
            font-size:28px;
            color:rgba(51,51,51,1);
            line-height:40px;
            margin-bottom:28px;
        }
    }
    .close{
        width:68px;
        height:68px;
        margin-top:40px;
    }
}
.mint-popup{background:transparent !important;}
</style>